import React, { useState, useContext, useEffect, useReducer } from "react";
import { useTranslation } from "react-i18next";
import ReCAPTCHA from "react-google-recaptcha";
import moment from 'moment-with-locales-es6'

import { GroupsImagesContext } from "../../domain-repository/GroupsImagesRepository";
import { DomainContext } from "../../domain-repository/DomainRepository";
import { saveLocalStorageTranslations } from "../../i18n";
import {
  mapLocalizations,
  transformLocalsArrayToObject,
} from "../select-language/SelectLanguagePage";

import { getBlockedTaxNumbers } from "../../services/ValidateTaxNumber";
import { saveSessionEnd } from "../../services/Metrics";
import { session } from "../../load-config";
import { getReservation } from "../../services/GetReservation";
import { getCountries } from "../../services/GetCountries";
import { getGroupsDetails } from "../../services/GetGroupsDetails";
import { validateGoogleCaptcha } from "../../services/ValidateGoogleCaptcha";
import { getStationsConfigurations } from "../../services/Stations";
import { verifyReservationWithRA } from "../review-rental-agreement/api";
import { getLanguages, getLocalizations } from "../../services/localizations";

import Footer from "../../components/Footer";
import Loading from "../../components/Loading";
import withLang from "../../withLang";
import SelectStation from "../select-pickup-details/SelectStation";
import SelectDate from "../select-pickup-details/selectDate";
import { useDisableBodyScroll } from "../../utils/useDisableBodyScroll";

function invalidSearchReferences(reference) {
  if (reference.toUpperCase().startsWith("DC-")) {
    return "insertConfirmationNumberAlert";
  }
  return null;
}

function StartSessionComp(props) {
  const { t, i18n } = useTranslation();

  const { getSetGroupsConfigurations } = useContext(GroupsImagesContext)

  const {
    setReservation,
    setCountries,
    setDriverInfo,
    language,
    setAppFlowConfigs,
    appVersionId,
    setSessionId,
    setGroupsDetails,
    pickupDate,
    kioskCurrentStationId,
    setBlockedTaxNumbersList,
    setStationsConfigurations,
    setAdditionalDriverInfo,
    setKioskCurrentStationId,
    setPickupDate,
  } = useContext(DomainContext);

  const [googleCaptchaResult, setGoogleCaptchaResult] = useState(null);

  const [resReference, setResReference] = useState("");
  const [isLoading, setIsLoading] = useState(false)

  function handleNextClick(e) {
    if (e) {
      e.preventDefault();
    }
    if (
      !resReference ||
      !kioskCurrentStationId ||
      !pickupDate ||
      !googleCaptchaResult ||
      !googleCaptchaResult.isValid
    ) {
      return;
    }

    setIsLoading(true);
    getReservationFromReference();
  }

  async function getReservationFromReference() {
    setIsLoading(true);

    let formatedResNumberOrRefMatches = resReference.match(/(.*)count$/i);

    const groupConfig = await getSetGroupsConfigurations();

    const blockedTaxNumbersList = await getBlockedTaxNumbers();
    setBlockedTaxNumbersList(blockedTaxNumbersList.blockedTaxNumbers);

    Promise.all([
      getReservation({
        resNumberOrReference:
          formatedResNumberOrRefMatches &&
          formatedResNumberOrRefMatches.length > 1
            ? formatedResNumberOrRefMatches[1]
            : resReference,
        stationId: kioskCurrentStationId,
        resCheckOutDate: pickupDate,
        appVersionId,
        language,
      }),
      getCountries(),
      getGroupsDetails(Object.keys(groupConfig)),
      getStationsConfigurations(),
    ])
      .then(([reservation, countries, groups, stationsConfigurationsRes]) => {
        setIsLoading(false);

        if (!reservation || !countries || !groups || groups.length === 0) {
          props.history.push(
            `/input-reservation-ref-error?resReference=${resReference}`
          );
        } else {
          if (!reservation.redirectUrl) {
            setReservation(reservation);
            setDriverInfo(reservation.listReservation);
            setAdditionalDriverInfo(reservation.listReservation);
            setAppFlowConfigs(reservation.appFlowConfigs);
            setSessionId(reservation.sessionId);
          }
          setCountries(
            countries.map((c) => ({ ...c, name: t(`country_${c.countryID}`) }))
          );
          setGroupsDetails(groups.groupsDetails);
          setStationsConfigurations(
            stationsConfigurationsRes.stationsConfigurations
          );

          if (reservation.redirectUrl) {
            return props.history.push(reservation.redirectUrl);
          }
          props.history.push("/review-reservation");
        }
      })
      .catch((err) => {
        setIsLoading(false);
        const errorMessage = err?.message || err || null;
        props.history.push({
          pathname: `/input-reservation-ref-error`,
          search: `resReference=${resReference}`,
          state: { errorMessage },
        });
      });
  }

  const searchAlert = invalidSearchReferences(resReference);

  const isNextDisabled =
    searchAlert ||
    !pickupDate ||
    !kioskCurrentStationId ||
    !resReference ||
    !googleCaptchaResult ||
    !googleCaptchaResult.isValid;

  return (
    <div style={{ height: "100lvh" }} className="flex flex-col">
      <Loading active={isLoading} message={t('searchingReservation')} />

      <div className="container flex items-center justify-between">
        <div onClick={() => props.history.push("/start")}>
          <img
            src={require(`../../assets/images/logo.png`)}
            alt="Guerin"
            className="img-fluid pt-3 pb-3"
          />
        </div>
        <LanguageDropdown />
      </div>

      <div className="grow flex flex-col">
        <div className="container grow flex flex-col items-center justify-center gap-4">
          <PickupDetails
            handleStationChange={setKioskCurrentStationId}
            handleDateChange={setPickupDate}
          />
          <form className="text-center w-full mt-4" onSubmit={handleNextClick}>
            <label
              htmlFor="referencia"
              className="text-uppercase"
              style={{ wordWrap: "break-word" }}
            >
              {t("inputReservationMessageMobile1")}
              <b>
                {t("inputReservationMessageMobile2")}
              </b>
            </label>
            <input
              autoComplete="off"
              id="referencia"
              type="text"
              className={`form-control text-center ${
                searchAlert ? "error" : ""
              }`}
              value={resReference}
              onChange={(e) => setResReference(e.target.value)}
            />
            {searchAlert !== null && (
              <div className="error-message">
                <p>{t(searchAlert)}</p>
              </div>
            )}
          </form>
          <ReCaptcha onResponse={(res) => setGoogleCaptchaResult(process.env.REACT_APP_GOOGLE_RECAPTCHA_DISABLE === "TRUE" ? { isValid: true } : res)} />
        </div>
        <Footer
          prevHidden
          nextDisabled={isNextDisabled}
          handleNextClick={handleNextClick}
        />
      </div>
    </div>
  );
}

export const StartSessionPage = withLang(StartSessionComp);

function ReCaptcha({ onResponse }) {
  const { language } = useContext(DomainContext);

  function onCaptchaChange(value) {
    if (!value) {
      return;
    }
    validateGoogleCaptcha(value)
      .then((res) => {
        onResponse({ isValid: res.success });
      })
      .catch((err) => {
        onResponse({ isValid: false });
      });
  }

  function onCaptchaExpire() {
    onResponse(null);
  }

  function onCaptchaError() {
    onResponse(null);
  }

  return (
    <div className="recaptcha w-100 mt-3">
      <ReCAPTCHA
        hl={language}
        sitekey={process.env.REACT_APP_GOOGLE_RECAPTCHA_KEY}
        onChange={onCaptchaChange}
        onExpired={onCaptchaExpire}
        onErrored={onCaptchaError}
      />
    </div>
  );
}

function LanguageDropdown({ onChange = () => { window.location.reload()} }) {
  const { i18n } = useTranslation();

  const { setLanguage, setLocalizationAssets, setLocalizations, localizations, language } =
    useContext(DomainContext);

  const [isLoading, setIsLoading] = useState(false);
  const [defaultLang, setDefaultLang] = useState(null);
  const [languages, setLanguages] = useState([]);
  const [optionsOpen, setOptionsOpen] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    getLanguages().then((res) => {
      setLanguages(res);
      const browserLang = language || (navigator.language || navigator.userLanguage).slice(
        0,
        2
      );
      const langObj = res.find((r) => r.id === browserLang) || res.find((r) => r.isDefault);
      const lang = langObj?.id || "en";
      setDefaultLang(lang);
      innerChangeLanguage(lang)
    });
  }, []);

  const innerChangeLanguage = (key) => {
    setOptionsOpen(false);
    const reload = key !== language || localizations.length === 0
    if (!reload) {
      setIsLoading(false);
      return null
    }
    setLanguage(key);

    function positiveHandler(locals) {
      i18n.setDefaultNamespace("translations");
      saveLocalStorageTranslations(key, locals);
      i18n.addResourceBundle(key, "translations", locals, true, true);
      i18n.changeLanguage(key).then((r) => {
        if (reload) {
          onChange(key);
        }
      });
    }

    setIsLoading(true);
    getLocalizations({ lang: key, system: "KIOSK" })
      .then((res) => {
        const mapped = mapLocalizations(key, defaultLang, res);
        setLocalizations(mapped);

        const mediaAssets = transformLocalsArrayToObject(
          mapped.filter((r) => r.type === "MEDIA")
        );
        setLocalizationAssets(mediaAssets);

        const texts = mapped.filter((r) => r.type === "TEXT");
        const obj = transformLocalsArrayToObject(texts);
        positiveHandler(obj);
      })
  };

  function handlePageClick(e) {
    const element = e.target;
    setOptionsOpen((s) => (element.id === "dropdown-input" ? !s : false));
  }

  return (
    <>
      <Loading active={isLoading} />
      {optionsOpen ? (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100%",
            height: "100%",
          }}
          onClick={handlePageClick}
        />
      ) : null}
      <div
        onClick={handlePageClick}
        className="select-custom"
        style={{ width: "75px" }}
      >
        <div
          id="dropdown-input"
          className={`select-selected ${
            optionsOpen ? "select-arrow-active" : ""
          }`}
          style={{ "--color": "black" }}
        >
          <img
            style={{ width: "20px", height: "20px", marginRight: "2px" }}
            src={require(`../../assets/images/language.png`)}
          />
          {language}
        </div>
        <div className={`select-items ${optionsOpen ? "" : "select-hide"}`}>
          {languages.map((lang) => (
            <div
              style={{ "--flag-img": `url(${lang.imageUrl})` }}
              key={lang.id}
              onClick={(e) => {
                innerChangeLanguage(lang.id);
                e.stopPropagation();
              }}
              value={lang.id}
            >
              {lang.id}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

function reducer(state, action) {
  switch (action.type) {
    case "FIELD":
      return { ...state, [action.payload.field]: action.payload.value };

    case "FIELDS":
      return { ...state, ...action.payload };

    default:
      return state;
  }
}

function PickupDetails({ handleStationChange, handleDateChange }) {
  const { t, i18n } = useTranslation();

  const dContext = useContext(DomainContext);

  const [state, dispatch] = useReducer(reducer, {
    pickupStationId: '',
    pickupDate: '',

    openSelectStation: false,
    openSelectDate: false,

    stations: [],

    loading: false,
  });

  const {
    pickupStationId,
    pickupDate,
    loading,
    stations,
    openSelectStation,
    openSelectDate,
  } = state;

  useDisableBodyScroll(openSelectStation || openSelectDate)

  useEffect(() => {
    const func = async () => {
      dispatch({ type: "FIELD", payload: { field: "loading", value: true } });

      const stationsRes = (await getStationsConfigurations())
        .stationsConfigurations;

      const stationsDetailed = stationsRes.map((s) => {
        return { ...s, label: t(s.name) };
      });

      dispatch({
        type: "FIELD",
        payload: { field: "stations", value: stationsDetailed },
      });

      if (stations.length === 1) {
        const value = stationsDetailed[0].stationId;
        handleStationClick(value);
      }
      dispatch({ type: "FIELD", payload: { field: "loading", value: false } });
    };

    func();
  }, [t]);

  function handleStationClick(station) {
    const value = station.stationId;
    dispatch({
      type: "FIELDS",
      payload: { pickupStationId: value, openSelectStation: false },
    });
    handleStationChange(value);
  }

  function handleDateClick(date) {
    const formattedDate = date
      ? `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
      : "";
    if (moment(formattedDate, "YYYY-MM-DD").isValid()) {
      dispatch({
        type: "FIELDS",
        payload: { pickupDate: formattedDate, openSelectDate: false },
      });
      handleDateChange(formattedDate);
    } else {
      dispatch({
        type: "FIELDS",
        payload: { pickupDate: "", openSelectDate: false },
      });
      handleDateChange("");
    }
  }

  function displayDate() {
    return pickupDate
      ? moment(pickupDate, "YYYY-MM-DD")
          .locale(i18n.language || "pt")
          .format("DD MMMM YYYY")
      : "";
  }

  function displayStationName() {
    const station = stations.find((s) => s.stationId === pickupStationId);
    return station?.label || "";
  }

  return (
    <>
      <div className="board-background w-100 row justify-content-center">
        <div className="col-md-6 col-sm-8">
          <div
            className={`btn btn-green w-100 px-5 py-2 my-1 map-pin enebled ${
              pickupStationId ? "done" : ""
            }`}
            onClick={() =>
              dispatch({
                type: "FIELD",
                payload: { field: "openSelectStation", value: true },
              })
            }
          >
            {pickupStationId ? displayStationName() : t("selectPickupStation")}
          </div>
        </div>
        <div className="col-md-6 col-sm-8">
          <div
            className={`btn btn-green w-100 px-5 py-2 my-1 calendar ${
              !pickupStationId ? "disabled" : ""
            } ${pickupDate ? "done" : ""} ${
              !pickupStationId ? "disabled" : ""
            }`}
            onClick={() =>
              pickupStationId &&
              dispatch({
                type: "FIELD",
                payload: { field: "openSelectDate", value: true },
              })
            }
          >
            {pickupDate ? displayDate() : t("selectPickupDate")}
          </div>
        </div>
      </div>
      {openSelectStation && (
        <SelectStation
          t={t}
          handleClose={() =>
            dispatch({
              type: "FIELD",
              payload: { field: "openSelectStation", value: false },
            })
          }
          stations={stations}
          handleStationClick={handleStationClick}
        />
      )}
      {openSelectDate && (
        <SelectDate
          t={t}
          handleClose={() =>
            dispatch({
              type: "FIELD",
              payload: { field: "openSelectDate", value: false },
            })
          }
          handleDateClick={handleDateClick}
          language={dContext.language}
        />
      )}
    </>
  );
}
